import type { Account, Contact, ContactAccount } from '@axiom/validation';
import { Api } from '@axiom/ui';

import LegacyApiHelper from '../classes/legacy-api-helper';
import { EnvUtil } from '../utils/env-util';

const api = new LegacyApiHelper('account');

export const addContactsToAccount = async ({
  accountId,
  contactIds,
}: {
  accountId: Account['id'];
  contactIds: Array<Contact['id']>;
}) => {
  const { data } = await api.POST(`/accounts/${accountId}/contacts`, {
    contactIds,
  });
  return data;
};

export const removeContactFromAccount = async ({
  accountId,
  contactId,
}: {
  accountId: Account['id'];
  contactId: Contact['id'];
}) => {
  const { data } = await api.DELETE(
    `/accounts/${accountId}/contacts/${contactId}`
  );
  return { data };
};

class AccountsLegacyApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  async createAccountContacts({
    accountId,
    contactIds,
  }: {
    accountId: Account['id'];
    contactIds: Array<Contact['id']>;
  }) {
    return super.write<{ data: ContactAccount[] }>({
      endpoint: `/accounts/${accountId}/contacts`,
      method: 'POST',
      body: { contactIds },
    });
  }
}

export const AccountsLegacyApi = new AccountsLegacyApiClass();
